<template>
  <div class="practice-base">
    <el-image
      class="banner pc"
      fit="cover"
      :src="require('@/assets/images/tjhj/red-background.png')"
    ></el-image>
    <div class="container content card-shadow">
      <div class="card">
        <el-image
          class="cover"
          fit="cover"
          :src="require('@/assets/images/tjhj/practice-base/banner.jpg')"
        ></el-image>
        <div class="card-info">
          <h1>天津海河教育园区思想政治教育实践基地</h1>
          <div class="position">
            <span class="label">地址</span>：
            <span class="value">天津市海河教育园区雅观路3号</span>
          </div>
          <div class="position">
            <span class="label">联系人</span>：
            <span class="value">郭老师</span>
          </div>
          <div class="position">
            <span class="label">电话</span>：
            <span class="value">13814789656</span>
          </div>
          <el-button class="view-btn" type="danger" @click="viewOnline">在线参观</el-button>
          <el-button class="view-btn xd" type="danger" @click="viewCode">立即预约</el-button>
          <el-button class="view-btn" type="danger" plain @click="viewCode">立即预约</el-button>
          <el-button class="view-btn news-btn" type="danger" @click="viewNews">红馆专题</el-button>
        </div>
      </div>
      <h1 class="underline">
        <span class="red-border">基地简介</span>
      </h1>
      <div class="img-wrapper">
        <el-image class="img" :src="require('@/assets/images/tjhj/practice-base/image1.jpg')"></el-image>
      </div>
      <div class="introduction">
        <p>天津海河教育园区思想政治教育实践基地（以下简称“实践基地”）以习近平新时代中国特色社会主义思想为指导，根据高职院校思想政治教育工作特点而建立的实践资源平台。实践基地建筑面积5000平米，四层楼，四个主题，分别为：“新时代、新思想”，“沿红路、寻初心”，“明明德、晓律法”，“立匠心、育匠人”。</p>
        <p>实践基地以提升思想政治理论课实践教学，加强思想政治教育第一课堂和第二课堂建设，构建“三全育人”大格局为目标，创新实践形式，改革思想政治理论课实践教学方式方法，通过学生在实践基地主体性的学习和体验，不断深化理论认知，进一步解决课堂理论教学中的重难点问题，增强思想政治理论课吸引力和获得感，从而入脑入心。</p>
        <p>实践基地除满足高校思想政治理论课实践教学外，还可以为社会团体、企事业单位提供党建教育，红色文化教育等，发挥其社会教育功能。</p>
      </div>
    </div>

    <div v-if="showBigCode" class="code-back">
      <div class="code-wrapper">
        <i class="iconfont iconguanbi" @click="showBigCode = false"></i>
        <el-image
          class="code"
          fit="cover"
          :src="require('@/assets/images/tjhj/practice-base/code.jpg')"
        ></el-image>
        <div class="code-tip">
          <div>扫描二维码关注公众号</div>进行在线预约
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "practiceBase",
  data() {
    return {
      showBigCode: false
    };
  },
  methods: {
    viewOnline() {
      window.open("https://720yun.com/t/b7vknyph7rm");
    },
    viewCode() {
      this.showBigCode = true;
    },
    viewNews() {
      window.open("#/tjxd/news/1725/2");
    }
  }
};
</script>

<style scoped>
.xd,
.hj {
  display: none;
}

.tjxd .xd {
  display: inline-block;
}

.tjhj .hj {
  display: inline-block;
}

.banner {
  display: block;
  height: 140px;
}

.tjxd .banner {
  display: none;
}

.content {
  position: relative;
  z-index: 2;
  margin-top: -90px;
  margin-bottom: 80px;
  padding: 30px;
  background-color: #fff;
  border: 1px solid #eaeaea;
}

.tjxd .content {
  margin-top: 30px;
}

.card {
  position: relative;
}

.card .cover {
  position: absolute;
  width: 380px;
  height: 240px;
  background-color: #eee;
}

.card .card-info {
  min-height: 240px;
  padding-left: 410px;
}

.card h1 {
  margin-bottom: 20px;
  height: 30px;
  line-height: 30px;
  font-size: 22px;
  color: #111111;
  overflow: hidden;
}

.card .position {
  margin-top: 10px;
  font-size: 16px;
  line-height: 22px;
}

.position .label {
  display: inline-block;
  width: 48px;
  height: 22px;
  text-align: justify;
  vertical-align: bottom;
  overflow: hidden;
}

.position .label:after {
  content: "";
  display: inline-block;
  width: 100%;
}

.view-btn {
  margin-top: 32px;
  margin-left: 0 !important;
  margin-right: 10px;
  width: 160px;
}

.news-btn {
  display: none;
}

.tjxd .news-btn {
  display: unset;
}

.underline {
  margin-top: 30px;
  margin-bottom: 30px;
  padding-bottom: 12px;
  line-height: 28px;
  font-size: 20px;
  color: #b92e32;
  border-bottom: 1px solid #e3e3e3;
}

.underline .red-border {
  padding-bottom: 13px;
  border-bottom: 3px solid #b92e32;
}

.tjxd .underline {
  color: #ec2f08;
}

.tjxd .underline .red-border {
  border-color: #ec2f08;
}

.img-wrapper {
  text-align: center;
}

.img {
  max-width: 100%;
}

.introduction {
  font-size: 14px;
  line-height: 28px;
  text-indent: 28px;
}

.code-back {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
}

.code-back .code-wrapper {
  position: absolute;
  margin: auto;
  top: 100px;
  left: 0;
  right: 0;
  width: 460px;
  height: 460px;
  padding: 19px 49px;
  background: #fafafa;
  border: 1px solid #e3e3e3;
  box-shadow: 0 5px 20px 2px rgba(0, 0, 0, 0.2);
  text-align: center;
  box-sizing: border-box;
}

.code-wrapper .iconfont {
  position: absolute;
  top: 2px;
  right: -56px;
  font-size: 28px;
  color: #444;
  cursor: pointer;
}

.code-back .code {
  display: block;
  margin: auto;
  width: 360px;
  height: 360px;
  background-color: #fff;
}

.code-back .code-tip {
  margin-top: 10px;
  line-height: 24px;
  font-size: 16px;
  color: #444444;
}

@media (max-width: 991px) {
  .card .cover {
    display: none;
  }

  .card .card-info {
    padding-left: 0;
  }
}

@media (max-width: 767px) {
  .content {
    margin-top: 0;
    margin-bottom: 10px;
    padding: 20px 15px;
    border: unset;
  }

  .tjxd .content {
    margin-top: 0;
  }

  .underline {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 16px;
  }

  .underline .red-border {
    padding-bottom: 10px;
  }

  .card .card-info {
    min-height: unset;
  }

  .card h1 {
    margin-bottom: 10px;
    height: auto;
    line-height: 22px;
    font-size: 16px;
    overflow: hidden;
  }

  .card .position {
    margin-top: 8px;
    font-size: 12px;
    line-height: 18px;
  }

  .position .label {
    width: 36px;
    height: 18px;
  }

  .view-btn {
    margin-top: 10px;
    margin-right: 2%;
    width: 48%;
  }

  .tjxd .view-btn {
    margin-right: 3%;
    width: 30%;
  }

  .code-back .code-wrapper {
    top: 0;
    width: 100%;
    height: 100%;
    padding: 100px 10% 0;
    border: none;
  }

  .code-wrapper .iconfont {
    top: 20px;
    right: 20px;
    font-size: 20px;
  }

  .code-back .code {
    width: 80%;
    height: auto;
  }

  .img-name {
    margin-top: 8px;
    margin-bottom: 10px;
    line-height: 20px;
    font-size: 12px;
  }
}
</style>
